import { MdErrorOutline } from 'react-icons/md';
export function ErrorFallback({ error, resetErrorBoundary }) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div role="alert" className="bg-white shadow-lg rounded-2xl p-6 max-w-md w-full text-center">
        <div className="flex justify-center mb-4 text-red-500">
          <MdErrorOutline className="w-10 h-10" />
        </div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Something went wrong</h2>
        {/* <pre className="text-sm text-red-600 whitespace-pre-wrap mb-4">{error.message}</pre> */}
        <pre className="text-sm text-red-600 whitespace-pre-wrap mb-4">   An unexpected issue occurred. Please try again later.</pre>
        <button
          onClick={resetErrorBoundary}
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
        >
          Try Again
        </button>
      </div>
    </div>
    );
  }